<template>
  <validation-provider
    tag="div"
    class="checkbox-field"
    :rules="rules"
    v-slot="{ errors }"
  >
    <div class="form-group" :class="{ '-has-error': errors.length > 0 }">
      <div
        class="form-check"
      >
        <input
          type="checkbox"
          class="form-check-input"
          :id="name"
          :name="name"
          :checked="value === true"
          :disabled="disabled"
          @change="$emit('input', $event.target.checked ? true : false)"
        >
        <label
          :for="name"
          class="form-check-label"
        >
          {{ label }}

          <span v-if="tip" :data-tooltip="tip">
          <ion-icon class="icon" name="help-circle-outline"></ion-icon>
        </span>
        </label>
      </div>

      <p class="description" v-if="errors.length > 0">{{ errors[0] }}</p>
    </div>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'CheckboxField',

  props: {
    name: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    value: {
      required: true,
    },
    tip: {
      required: false,
      type: String,
      default: '',
    },
    disabled: {
      required: false,
      type: Boolean,
    },
    required: {
      required: false,
      type: Boolean,
    },
  },

  computed: {
    rules() {
      return '';
    },
  },

  components: {
    ValidationProvider,
  },
};
</script>

<style lang="scss" scoped>
  .checkbox-field {
    grid-column: 1 / span 2;

    > .form-group {
      > .form-check {
        > .form-check-label {
          display: inline;
        }
      }
    }
  }
</style>
